import React from 'react';
import { Page, Header, Content } from '@backstage/core-components';
import { Grid } from '@material-ui/core';
import { useApi, configApiRef } from '@backstage/core-plugin-api';
import { useTranslation } from 'react-i18next';

export const LoggedInHomePage = () => {
  const { t } = useTranslation('serviceRegistry');
  const ComponentName = 'LoggedInHomePage';

  const config = useApi(configApiRef);
  const appTitle = config.getOptionalString('app.title') || 'Service Registry';

  return (
    <React.Fragment>
      <Page themeId="home" key={ComponentName}>
        <Header 
          title={appTitle}
        >
        </Header>
        <Content>
          <Grid item>
            <p>{t('home.welcome', { name: appTitle })}</p>
          </Grid>
        </Content>
      </Page>
    </React.Fragment>
  );
};
